// extracted by mini-css-extract-plugin
export default {"rozhaOne":"fonts_rozhaOne__BHtWb","courierNew":"fonts_courierNew__vLFjE"};